module.exports = __webpack_public_path__ + "static/media/RA26.f9b95bfc.gif";